module.exports = __webpack_public_path__ + "img/file-black.cb898380.svg";